(function($) {
    $(function() {
        if ('IntersectionObserver' in window) {
            window.lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (!entry.isIntersecting) return;
                    var lazyImage = entry.target;
                    var imgLarge = new Image();
                    imgLarge.src = lazyImage.dataset.src;
                    if (lazyImage.dataset.srcset) imgLarge.srcset = lazyImage.dataset.srcset;
                    imgLarge.onload = function(e) {
                        e.target.classList.add('loaded');
                    }
                    imgLarge.classList.add('full-size');
                    lazyImage.after(imgLarge);
                    window.lazyImageObserver.unobserve(lazyImage);
                });
            });
            
            var lazyLoadImages = function() {
                var lazyImages = [].slice.call(document.querySelectorAll('img.lazy:not(.lazy-observed)'));
                lazyImages.forEach(function(lazyImage) {
                    lazyImage.classList.add('lazy-observed')
                    window.lazyImageObserver.observe(lazyImage);
                });
            }

            lazyLoadImages();
            window.setTimeout(lazyLoadImages, 2500);
        } else {
            console.error('IntersectionObserver not found!');
        }
    });
})(jQuery);